var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M20 0C8.955 0 0 8.955 0 20s8.955 20 20 20 20-8.955 20-20S31.045 0 20 0m-5.385 29.23H10.77V15.386h3.846zm-1.934-15.384h-.022c-1.148 0-1.89-.855-1.89-1.924 0-1.091.766-1.922 1.934-1.922 1.17 0 1.89.83 1.912 1.922 0 1.068-.742 1.924-1.934 1.924m16.55 15.385h-3.846v-6.923c0-2.308-1.113-3.077-2.308-3.077-1.112 0-2.308.769-2.308 3.077v6.923h-3.846V15.385h3.846v2.307c.264-.754 1.526-2.307 3.846-2.307 3.077 0 4.616 2.307 4.616 6.153z"
})));
export default SvgInLogo;